var _rect, _title, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkerDistrick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 60,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7747 0.0388621C16.3619 0.494402 12.0728 2.25609 8.556 5.05765C4.43891 8.33741 1.46468 13.2273 0.377964 18.5034C-0.0568457 20.6143 -0.125945 24.0788 0.219856 26.4275C0.53895 28.5943 1.49709 31.589 2.60666 33.8872C4.51319 37.8363 6.98879 41.1599 13.491 48.5001C15.9022 51.222 16.6467 52.0805 17.9314 53.6198C19.6157 55.6379 20.3723 56.6258 22.0773 59.0332C22.9592 60.2782 23.0282 60.2874 23.7327 59.2529C24.3652 58.324 26.1314 55.9742 27.2902 54.5196C28.3915 53.1373 28.8853 52.5626 32.5681 48.3775C36.9524 43.3953 38.4093 41.6521 39.8653 39.6466C43.3955 34.784 45.3157 30.2188 45.8956 25.3095C46.0351 24.1286 46.0347 21.6885 45.8948 20.5364C45.4592 16.9481 44.3446 13.7445 42.4988 10.7754C39.6718 6.22784 35.2694 2.77186 30.1942 1.11598C28.601 0.596171 27.1605 0.283328 25.635 0.125926C24.5223 0.0111069 21.5579 -0.0419526 20.7747 0.0388621Z",
    fill: "#7cb3ff",
    id: "svg_1",
    className: ""
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    id: "svg_2",
    className: ""
  })), /*#__PURE__*/React.createElement("foreignObject", {
    fill: "white",
    strokeDashoffset: "",
    fillRule: "evenodd",
    fontSize: 25,
    fontFamily: "Georgia, serif",
    letterSpacing: 0,
    wordSpacing: 0,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_5",
    x: 15.61375904083252,
    y: 10.248676896095276,
    width: 91,
    height: 67,
    style: {
      color: "#7cb3ff"
    },
    className: "",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("p", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      border: "none",
      outline: "none",
      fontSize: "inherit",
      lineHeight: "1em",
      padding: 0,
      margin: 0
    }
  }, "\u0420"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerDistrick);
export default __webpack_public_path__ + "static/media/marker-districk.77b9f6794840977da34833a199e0ba07.svg";
export { ForwardRef as ReactComponent };